export default __webpack_public_path__ + "static/media/optimism.47fe80b7.png";